import Nav from '../components/nav';

const classes = {
    siteSearchForm: ".js-search-form",
    lazyLoadVideos: ".js-vid-lazy",
    productFacets: ".js-prd-facets",
    imageViewers: ".js-imgv",
    imageMagnifiers: ".js-magnify",
    accordians: ".js-accord",
    tabs: ".js-tabs",
    sliders: ".js-slider",
    scrollTos: ".js-scroll-to",
    modals: ".js-modal",
    overlay: ".js-overlay",
    overlayEles: ".js-hover-ovl",
    glides: ".js-glide",
    promoBar: ".js-promo-bar",
    hubspotForms: ".js-hs-form",
    maxWidthImgs: ".js-img-rsp-mw",
    forms: ".js-form",
    gatedBtns: ".js-gated-btn",
    expanders: ".js-expand",
    arModelViewers: ".js-vbsmv",
    scrollTopBtn: ".js-scroll-top",
};

document.addEventListener("DOMContentLoaded", function (event: any) {
    if (document.querySelector(classes.scrollTopBtn)) {
        import('../components/scrollTop').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.lazyLoadVideos)) {
        import('../components/lazyLoadVideos').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.siteSearchForm)) {
        import('../components/siteSearch').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.productFacets)) {
        import('../components/productFacets').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.imageViewers)) {
        import('../components/imageViewer').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.imageMagnifiers)) {
        import('../components/imageMagnifier').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.accordians)) {
        import('../components/accordian').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.tabs)) {
        import('../components/tabs').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.sliders)) {
        import('../components/slider').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.scrollTos)) {
        import('../components/scrollTo').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.modals)) {
        import('../components/modal').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.glides)) {
        import('../components/glides').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.promoBar)) {
        import('../components/promoBar').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.hubspotForms)) {
        import('../components/hubspotForm').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.maxWidthImgs)) {
        import('../components/maxWidthImg').then(md => {
            md.default.init();
        });
    } 

    if (document.querySelector(classes.gatedBtns)) {
        import('../components/gated').then(md => {
            md.default.init();
        });
    } 

    if (document.querySelector(classes.forms)) {
        import('../components/forms').then(md => {
            md.default.init();
        });
    } 

    if (document.querySelector(classes.expanders)) {
        import('../components/expand').then(md => {
            md.default.init();
        });
    } 

    if (document.querySelector(classes.arModelViewers)) {
        import('../components/arModelViewer').then(md => {
            md.default.init();
        });
    } 

    Nav.init();
});